import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MuiToastService } from '@move/ui';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CUSTOM_HEADER_PREFIX } from './custom-header-prefix';
import { MmuApiBaseService } from './mmu-api-base.service';

@Injectable()
export class MmuServerErrorInterceptor implements HttpInterceptor {
  static readonly ignoreHeader = CUSTOM_HEADER_PREFIX + '-ignore-server-error-interception';

  protected readonly i18n = {
    title: 'global.error.request.serverError.title',
    msg: 'global.error.request.serverError.message'
  };

  constructor(protected api: MmuApiBaseService, protected translate: TranslateService, protected toastService: MuiToastService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only intercept API requests that did not add the MmuAuthInterceptor.ignoreHeader
    if (this.api.isApiRequest(request) && !request.headers.has(MmuServerErrorInterceptor.ignoreHeader)) {
      return next.handle(request).pipe(
        catchError((err) => {
          // Display an error toast in case of 500 server response
          if (err instanceof HttpErrorResponse && err.status === 500) {
            this.showServerErrorToast();
          }

          return throwError(err);
        })
      );
    } else {
      // Do not intercept requests that are not API requests (e.g. static content)
      return next.handle(request);
    }
  }

  protected showServerErrorToast() {
    this.translate.get([this.i18n.msg, this.i18n.title]).subscribe((i18n) => {
      this.toastService.danger(i18n[this.i18n.msg], i18n[this.i18n.title], {
        closeButton: true,
        tapToDismiss: false
      });
    });
  }
}
